const confettiConfig = {
  confettiCount: 500,
  gravity: 0.5,
  terminalVelocity: 5,
  drag: 0.075,
  colors: [
    { front: 'red', back: 'darkred' },
    { front: 'green', back: 'darkgreen' },
    { front: 'blue', back: 'darkblue' },
    { front: 'yellow', back: 'darkyellow' },
    { front: 'orange', back: 'darkorange' },
    { front: 'pink', back: 'darkpink' },
    { front: 'purple', back: 'darkpurple' },
    { front: 'turquoise', back: 'darkturquoise' }
  ]
}

export default confettiConfig
